import React from 'react';

export interface MasHorizontalIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const MasHorizontalIcon: React.FC<MasHorizontalIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.334 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-14 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
    </svg>
  );
};

export default MasHorizontalIcon;
